import template from '../ppn.public/ppn.public.html';
import { PpnPublicCtrl } from './ppn.public.controller';

routesConfig.$inject = ['$stateProvider'];

export function routesConfig($stateProvider) {
  $stateProvider
    .state('navi', {
      template,
      controller: PpnPublicCtrl,
      abstract: true,
    })
    .state('navi.base', {
      url: '/navi',
    });
}
